import { Activity, LineChart, ShieldCheck } from "lucide-react";
import { Logo } from "@/components/Logo";

export default function Login() {
  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/trade";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(
      redirectUrl
    )}`;
  };

  return (
    <div className="min-h-screen bg-[#08090A] text-zinc-100 flex flex-col">
      <div className="border-b border-zinc-800 px-5 py-4 flex items-center gap-2">
        <Logo size={24} />
      </div>
      <div className="flex-1 grid lg:grid-cols-2 max-w-[1600px] w-full mx-auto">
        <div className="flex flex-col justify-center gap-8 p-8 lg:p-16 border-r border-zinc-800">
          <div>
            <p className="text-xs tracking-[0.2em] uppercase font-semibold text-zinc-400 mb-4">
              MT5 Execution Terminal
            </p>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-bold tracking-tight leading-[1.05]">
              Risk-gated
              <br />
              <span className="text-emerald-500">order execution.</span>
            </h1>
            <p className="mt-6 text-sm text-zinc-400 max-w-md leading-relaxed">
              Admin-locked risk parameters, backend-enforced limits, automatic TP1
              partial closes and a live positions blotter.
            </p>
          </div>
          <button
            data-testid="google-signin-btn"
            onClick={signIn}
            className="w-fit rounded-sm bg-emerald-600 hover:bg-emerald-500 text-white px-6 py-3 text-sm font-semibold tracking-wide transition-colors duration-200 active:scale-95"
          >
            Sign in with Google
          </button>
          <p className="text-xs text-zinc-400 font-mono">
            Access is granted by the admin email allowlist.
          </p>
        </div>
        <div className="hidden lg:flex flex-col justify-center gap-px p-16">
          {[
            { i: ShieldCheck, t: "Backend enforced", d: "Kill switch, daily loss cap, trade window, max open trades." },
            { i: LineChart, t: "TP1 / TP2 ladder", d: "1s monitor fires a partial counter-order at TP1; remainder runs to native TP." },
            { i: Activity, t: "Live blotter", d: "Instant EA push updates, partial or full manual close, tighten-only stop loss." },
          ].map(({ i: Icon, t, d }) => (
            <div key={t} className="border border-zinc-800 -mb-px p-6 hover:bg-zinc-900/60 transition-colors duration-200">
              <Icon className="h-4 w-4 text-emerald-500 mb-3" />
              <p className="text-sm font-semibold">{t}</p>
              <p className="text-xs text-zinc-400 mt-1 leading-relaxed">{d}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
